<template>
  <h1>
    Take out your binoculars<br />
    and become a birdwatcher!
  </h1>
</template>

<script>
export default {
  mounted() {
    setTimeout(() => {
      this.$emit("next");
    }, 3400);
  },
};
</script>

